import { render, staticRenderFns } from "./calendar-facet-event-page-url.vue?vue&type=template&id=4e19afec&"
import script from "./calendar-facet-event-page-url.vue?vue&type=script&lang=js&"
export * from "./calendar-facet-event-page-url.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports